export default "__VITE_ASSET__Cazxy$qU__"